import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Grid2, Typography } from '@mui/material';
import OptionSelector from './OptionSelector';
import CreateXMLTopologyFromFTPForm from './CreateXMLTopologyFromFTPForm';
import S12ThresholdsHistoryUpdateForm from './S12ThresholdsHistoryUpdateForm';
import VTKDataRefreshForm from './VTKDataRefreshForm';
import VTKDataRefreshEmailForm from './VTKDataRefreshEmailForm';
import VTKDataRefreshOneDriveForm from './VTKDataRefreshOneDriveForm';
import TrafficTrendsDataRefreshForm from './TrafficTrendsDataRefreshForm';
import { OPTIONS, MENU_ITEMS_CONFIG } from './Constants';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const OPTION_LABELS = Object.fromEntries(
	MENU_ITEMS_CONFIG.map(item => [item.value, item.text])
);

const DataManagementForm = () => {
	const classes = useStyles();
	const [selectedOption, setSelectedOption] = useState(OPTIONS.NONE);

	return (
		<Grid2 container spacing={2}>
			<Grid2 item size={12}>
				<div className={clsx(classes.container)}>
					<OptionSelector onChange={setSelectedOption} value={selectedOption} />
				</div>
			</Grid2>

			<Grid2 item size={12}>
				{selectedOption !== OPTIONS.NONE && (
					<Card className={classes.content}>
						<CardContent>
							<Grid2 item size={12}>
								<Typography align="center" variant="h4" gutterBottom component="div">
									{OPTION_LABELS[selectedOption]}
								</Typography>
							</Grid2>
							<div className={clsx(classes.container)}>
								{selectedOption === OPTIONS.VTK_DATA_REFRESH && <VTKDataRefreshForm />}
								{selectedOption === OPTIONS.VTK_DATA_REFRESH_EMAIL && <VTKDataRefreshEmailForm />}
								{selectedOption === OPTIONS.S12_THRESHOLDS_UPDATE && <S12ThresholdsHistoryUpdateForm />}
								{selectedOption === OPTIONS.CREATE_XML_TOPOLOGY && <CreateXMLTopologyFromFTPForm />}
								{selectedOption === OPTIONS.VTK_DATA_REFRESH_ONEDRIVE && <VTKDataRefreshOneDriveForm />}
								{selectedOption === OPTIONS.TRAFFIC_TRENDS_DATA_REFRESH && <TrafficTrendsDataRefreshForm />}
							</div>
						</CardContent>
					</Card>
				)}
			</Grid2>
		</Grid2>
	);
};

export default DataManagementForm;